import TurndownService from 'turndown'

export const prepareMarkdown = (str = '') => str
  .replaceAll('\n', '\n\n')

export const prepareDescription = (str = '') => {
  if (!str) { return '' }

  const hasHtml = str.includes('<p>')
  // TODO используем Turndown, пока у компаний остались deprecated описания в формате html
  const description = hasHtml ? new TurndownService().turndown(str) : prepareMarkdown(str)

  return description
}
